import { Button, IconHeartOff16, IconHeartOn16, TPlacement, TooltipDesktop } from '@cian/ui-kit';

import { FC } from 'react';

import { cardOfferDataSelector, useCardContext } from 'shared/context/CardContext';

import { ControlWrapper } from '../ControlWrapper';

import { useToggleFavorite } from './internal/hooks/useToggleFavorite';

type FavoriteContainerProps = {
  tooltipPlacement?: TPlacement;
  isVisible?: boolean;
};

export const FavoriteContainer: FC<FavoriteContainerProps> = props => {
  const { tooltipPlacement = 'left', isVisible = false } = props;
  const cardContext = useCardContext();
  const {
    extendedProperties: { isFavorite },
  } = cardOfferDataSelector(cardContext);
  const toggleFavorite = useToggleFavorite();

  return (
    <ControlWrapper visible={isVisible || isFavorite}>
      <TooltipDesktop
        placement={tooltipPlacement}
        theme="black"
        title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      >
        <Button
          beforeIcon={isFavorite ? <IconHeartOn16 color="error_100" /> : <IconHeartOff16 />}
          data-testid="FavoritesControl"
          size="XS"
          theme="stroke_secondary"
          onClick={toggleFavorite}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
